export default __webpack_public_path__ + "9df6a4920169acdba5a7452392538e7d.jpg";